module.exports = __webpack_public_path__ + "static/media/weather.b1c8b8c9.png";